import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';

import { discountsQuery_account_discounts as Discount } from './types/discountsQuery';

const discountsQuery = gql`
  query discountsQuery($accountId: Int!) {
    account(id: $accountId) {
      discounts {
        couponName
        couponType
        id
      }
      id
    }
  }
`;

type CouponType = 'fr' | 'other' | 'papa' | 'sbap';

export const useDiscounts = () => {
  const { accountId } = useCurrentAccountId();

  const { data, error, loading } = useQuery(discountsQuery, {
    skip: !accountId,
    variables: {
      accountId,
    },
  });

  const discounts = data?.account?.discounts ?? [];

  const hasDiscount = (couponType: CouponType) => {
    return (
      discounts.some(
        (discount: Discount) => discount.couponType === couponType
      ) ?? false
    );
  };

  const numDiscounts = (couponType: CouponType) => {
    return discounts.filter(
      (discount: Discount) => discount.couponType === couponType
    ).length;
  };

  return {
    discounts,
    error: error ? 'Error loading discount information.' : undefined,
    hasDiscount,
    isLoading: loading,
    numDiscounts,
  };
};
